import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const getKeyAccountListApi = async (query) => {
  const res = await Get(`${ApiPath.KeyAccount}/station/${query?.stationCode}`, query);
  return res.data;
};

export const getKeyAccountCollectionListApi = async (query) => {
  const { stationCode, ...queryParams } = query;
  const res = await Get(`${ApiPath.KeyAccount}/collection/station/${stationCode}`, queryParams);
  return res.data;
};

export const createKeyAccountCollectionApi = async (query) => {
  const res = await Post(`${ApiPath.KeyAccount}/collection`, query);
  return res.data;
};

export const getKeyAccountCollectionByIdApi = async (query) => {
  const res = await Get(`${ApiPath.KeyAccount}/collection/${query?.id}`, query);
  return res.data;
};

export const updateKeyAccountByIdApi = async (query) => {
  const res = await Put(`${ApiPath.KeyAccount}/${query?.id}`, query);
  return res.data;
};
